import { render, staticRenderFns } from "./quotes-search.vue?vue&type=template&id=afc502cc"
import script from "./quotes-search.vue?vue&type=script&lang=js"
export * from "./quotes-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports